// PartBPage3.jsx - Secondary Stage Part B Page 3 (Teacher Assessment - Stage 1) for HPC Report
import React from 'react';

const PartBPage3 = ({ data }) => {
  // CORRECT PATH: data.stage1 (not data.teacher_assessment_stage_1)
  const stage1Data = data?.stage1 || {
    awareness: [],
    sensitivity: [],
    creativity: [],
    comments: ''
  };

  const awarenessItems = [
    "Guiding questions created by the learner demonstrate a clear understanding of project goals and objectives.",
    "The learner identifies potential challenges and proposes solutions.",
    "The learner develops a plan for project execution.",
    "The learner can clearly communicate project ideas and plans to other group members.",
    "The learner can successfully identify existing content knowledge and gaps in their understanding."
  ];

  const sensitivityItems = [
    "The learner actively seeks input from all group members during planning.",
    "The learner tries to support fair distribution of tasks and responsibilities including all genders.",
    "The learner ensures that decisions are made collaboratively.",
    "The learner actively maintains a shared understanding with the group.",
    "The learner can handle different opinions in the group respectfully."
  ];

  const creativityItems = [
    "The learner is able to brainstorm about project execution and presentation.",
    "The learner demonstrates curiosity in proposing sources of material beyond conventional resources.",
    "The learner demonstrates initiative in proposing solutions to possible barriers.",
    "The learner can provide creative input to decide the roles of group members.",
    "The learner can go beyond the defined features of the project prompt/task and add a unique element to it."
  ];

  const renderCheckboxSection = (title, items, category) => {
    const checkedIndices = stage1Data[category] || [];
    const total = checkedIndices.length;

    return (
      <div style={{ marginBottom: '16px' }}>
        <div style={{
          backgroundColor: '#F4A460',
          color: 'white',
          padding: '8px 12px',
          fontWeight: 'bold',
          fontSize: '11px',
          marginBottom: '8px'
        }}>
          {title}
        </div>
        <div style={{
          backgroundColor: '#FFE5D5',
          padding: '12px'
        }}>
          {items.map((item, index) => (
            <div key={index} style={{
              display: 'flex',
              alignItems: 'flex-start',
              marginBottom: '6px',
              fontSize: '11px',
              lineHeight: '1.4'
            }}>
              <div style={{
                width: '16px',
                height: '16px',
                border: '2px solid #333',
                marginRight: '8px',
                flexShrink: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginTop: '1px',
                fontSize: '12px'
              }}>
                {checkedIndices.includes(index) && '✓'}
              </div>
              <span>{item}</span>
            </div>
          ))}
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            marginTop: '10px',
            fontSize: '11px',
            fontWeight: 'bold'
          }}>
            <span style={{ marginRight: '10px' }}>Total number of (✓):</span>
            <div style={{
              width: '35px',
              height: '35px',
              border: '3px solid #F4824C',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: 'bold',
              fontSize: '14px'
            }}>
              {total}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderText = (text) => {
    if (!text || text.trim() === '') return <div style={{ fontSize: '11px', color: '#999' }}>-</div>;
    return <div style={{ fontSize: '11px', lineHeight: '1.5', whiteSpace: 'pre-wrap' }}>{text}</div>;
  };

  return (
    <div className="report-page" style={{
      width: '210mm',
      minHeight: '297mm',
      padding: '20mm',
      backgroundColor: 'white',
      boxSizing: 'border-box',
      fontFamily: 'Arial, sans-serif',
      position: 'relative'
    }}>
      {/* Decorative Corners */}
      <div style={{
        position: 'absolute',
        top: 0,
        right: 0,
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '0 80px 80px 0',
        borderColor: 'transparent #F4824C transparent transparent'
      }} />

      {/* Header */}
      <div style={{
        backgroundColor: '#F4824C',
        color: 'white',
        fontSize: '14px',
        fontWeight: 'bold',
        padding: '10px',
        textAlign: 'center',
        marginBottom: '20px'
      }}>
        Stage 1
      </div>

      {/* Teacher Assessment Label */}
      <div style={{
        backgroundColor: '#F4824C',
        color: 'white',
        padding: '8px 14px',
        fontWeight: 'bold',
        fontSize: '12px',
        display: 'inline-block',
        marginBottom: '12px'
      }}>
        Teacher Assessment
      </div>

      <div style={{
        fontSize: '11px',
        fontWeight: 'bold',
        marginBottom: '12px'
      }}>
        Tick (✓) all statements that apply.
      </div>

      {renderCheckboxSection('Awareness', awarenessItems, 'awareness')}
      {renderCheckboxSection('Sensitivity', sensitivityItems, 'sensitivity')}
      {renderCheckboxSection('Creativity', creativityItems, 'creativity')}

      {/* Comments Section */}
      <div style={{ marginTop: '20px' }}>
        <div style={{
          fontWeight: 'bold',
          fontSize: '11px',
          marginBottom: '8px'
        }}>
          Brief comments and pedagogical interventions recommended:
        </div>
        <div style={{
          backgroundColor: '#FFE5D5',
          padding: '12px',
          minHeight: '80px',
          borderRadius: '4px'
        }}>
          {renderText(stage1Data.comments)}
        </div>
      </div>

      {/* Page Number */}
      <div style={{
        position: 'absolute',
        bottom: '15mm',
        left: '50%',
        transform: 'translateX(-50%)',
        fontSize: '10px',
        color: '#666',
        fontWeight: 'bold'
      }}>
        13
      </div>

      {/* Bottom decorative corners */}
      <div style={{
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '60px 0 0 60px',
        borderColor: 'transparent transparent transparent #F4824C'
      }} />
      <div style={{
        position: 'absolute',
        bottom: 0,
        right: 0,
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '60px 60px 0 0',
        borderColor: 'transparent #F4824C transparent transparent',
        opacity: 0.3
      }} />
    </div>
  );
};

export default PartBPage3;
